import axios from "../../config/axiosConfig";
import {
  PRODUCTION_REGISTER_SIZING_REPORT_REQUEST,
  PRODUCTION_REGISTER_SIZING_REPORT_SUCCESS,
  PRODUCTION_REGISTER_SIZING_REPORT_FAILURE,
  PRODUCTION_REGISTER_SIZING_FILTER_REPORT_REQUEST,
  PRODUCTION_REGISTER_SIZING_FILTER_REPORT_SUCCESS,
  PRODUCTION_REGISTER_SIZING_FILTER_REPORT_FAILURE,
} from "../types/production-register-sizing-report-types";

export const getProductionRegisterSizingReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REGISTER_SIZING_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };

      const defaultParams2 = {
        book_ids: params?.book_ids,
        filterType: params?.filterType, 
        selectedBills: params?.selectedBills, 
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const data = { ...defaultParams, ...defaultParams2 };

      // Log the request parameters
      // console.log('Request Param Datas >>>>>>>>>>>>>>>>>>>>>>>>', requestParams);

      // Construct the complete URL with query parameters
      // const queryString = new URLSearchParams(requestParams).toString();
      // const fullUrl = `/production-register-report/sizing?${queryString}`;

      // Log the full URL (to debug)
      // console.log('Complete API Request URL: ', fullUrl);

      // Make API call
      return axios.post('/production-register-report/sizing', data, { params: data }).then((response) => {
        console.log('API Response Data: a', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PRODUCTION_REGISTER_SIZING_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: PRODUCTION_REGISTER_SIZING_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: PRODUCTION_REGISTER_SIZING_REPORT_FAILURE, error: error.message });
    }
  };
};

export const getProductionRegisterSizingFilterDetail = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: PRODUCTION_REGISTER_SIZING_FILTER_REPORT_REQUEST });
      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
        commanMaster: auth?.company?.Common_Master,
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams };
      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/production-register-report/filter-detail/sizing?${queryString}`;
      // Log the full URL (to debug)
      console.log('Complete API Request URL: ', fullUrl);
      // Make API call
      return axios.get(fullUrl).then((response) => {
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: PRODUCTION_REGISTER_SIZING_FILTER_REPORT_SUCCESS, payload: response.data });
        }
      }).catch((error) => {
        console.error("Error fetching Sales Register Report:", error);
        dispatch({ type: PRODUCTION_REGISTER_SIZING_FILTER_REPORT_FAILURE, error: error.message });
      });
    } catch (error) {
      console.error("Error fetching Sales Register Report:", error);
      dispatch({ type: PRODUCTION_REGISTER_SIZING_FILTER_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearProductionRegisterSizingReport = () => {
  return async (dispatch) => {
    dispatch({ type: PRODUCTION_REGISTER_SIZING_REPORT_SUCCESS, payload: {} });
  }
}
